var map = {
	"./flag_DE.png": 37,
	"./flag_EN.png": 38,
	"./flag_ES-ES.png": 39,
	"./flag_FR-FR.png": 40,
	"./flag_IT-IT.png": 41,
	"./flag_PT-BR.png": 42,
	"./flag_PT-PT.png": 43
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46;